import scss from "./NotificationsList.module.scss";
import { useTranslation } from "react-i18next";

/**
 * Show the list of all notifications.
 *
 * @param {PayloadListNotifications[]} notifications The notifications to show.
 * @param {PayloadListNotifications} selected The currently selected notification.
 * @param {boolean} isLoading True to suggest that the notifications are still loading.
 * @param {function(id: int)} onSelectedId Invoked when an item is selected.
 *
 * @return {JSX.Element}
 * @constructor
 */
const NotificationsList = ({ notifications, selected, isLoading, onSelected, translateKey }) => {
    const { t } = useTranslation();

    // Get the class names for the item
    return (
        !isLoading && (
            <div className={scss.list}>
                {(notifications ?? []).length === 0 ? (
                    <p className={scss.emptyList}>Nema obaveštenja za prikaz.</p>
                ) : (
                    notifications.map((notification) => (
                        <button
                            type="button"
                            key={notification.id}
                            className={`${scss.item} ${notification.id === selected?.id ? scss.active : ""}`}
                            onClick={() => onSelected(notification)}
                            aria-pressed={notification.id === selected?.id}
                        >
                            <span className={scss.itemTitle}>{notification.title}</span>
                            {!notification.seen_date && <span className={scss.unreadDot} title={t(`${translateKey}-text-this_is_new_message`)} />}
                        </button>
                    ))
                )}
            </div>
        )
    );
};

export default NotificationsList;
